// extracted by mini-css-extract-plugin
export var calories = "menuCarouselCard-module--calories--b9546";
export var ctaIcon = "menuCarouselCard-module--cta-icon--6f8cb";
export var ctaSection = "menuCarouselCard-module--cta-section--ff431";
export var ctaText = "menuCarouselCard-module--cta-text--f6fc6";
export var description = "menuCarouselCard-module--description--9e118";
export var descriptionSection = "menuCarouselCard-module--description-section--d8449";
export var descriptionSeparator = "menuCarouselCard-module--description-separator--3ca26";
export var expandOnHover = "menuCarouselCard-module--expand-on-hover--3dab0";
export var eyebrow = "menuCarouselCard-module--eyebrow--c4db5";
export var image = "menuCarouselCard-module--image--896ad";
export var imageSection = "menuCarouselCard-module--image-section--551e1";
export var menuCarouselCard = "menuCarouselCard-module--menu-carousel-card--50ef8";
export var menuCarouselCardWrapper = "menuCarouselCard-module--menu-carousel-card-wrapper--3f4b7";
export var title = "menuCarouselCard-module--title--4d17c";
export var titleSection = "menuCarouselCard-module--title-section--63910";